import React, { Component } from 'react';
import LinkWithParagraph from '../atoms/Refactorizaction/LinkWithParagraph';

const TextAltImage = "Busco empleo temporal o de freelancer"

class BannerPromotional extends Component {
    constructor(props) {
        super(props)

        this.ActiveContainerContact = this.ActiveContainerContact.bind(this)
        this.DesactiveContainerContact = this.DesactiveContainerContact.bind(this)
    }

    ActiveContainerContact() {
        const ContactBP = document.getElementById("container-contact-bp")
        ContactBP.classList.add("active")
    }
    
    DesactiveContainerContact() {
        const ContactBP = document.getElementById("container-contact-bp")
        ContactBP.classList.remove("active")
    }

    render() {
        return(
        <>
            <aside className="aside-banner">
                <div className="container-descriptions">
                    <h2 className="title-banner-promotional">Tu buscas un empleado y yo busco un trabajo</h2>
                    <p className="description-banner-promotional">Cualquiera que busque una interfaz linda, y con un flujo bueno para el usuario sea para aplicaciones o sitios webs, y/o quieres una pagina web y llevar el diseño UI de interfaz a codigo para tu sitio web, tengo la experiencia para hacer el trabajo.</p>
                    <p className="description-banner-promotional">Costo del trabajo depende del tamaño y calidad (aunque esto es seguro) del proyecto</p>
                    <p className="description-banner-promotional hastags">#freelancer #ui/ux #progrmacionfrontend #interfaz</p>
                    <button onClick={this.ActiveContainerContact} className="button-contact-banner-promotional">Contacto</button>
                </div>
                <img className="image-banner-promotional one" src="https://raw.githubusercontent.com/eliud-cesar/Portfolio-Data-Base/master/Freelancer/UI-UX.png" alt={TextAltImage} />
                <img className="image-banner-promotional two" src="https://raw.githubusercontent.com/eliud-cesar/Portfolio-Data-Base/master/Freelancer/WEB.png" alt={TextAltImage} />
                

                <div onClick={this.DesactiveContainerContact} id="container-contact-bp" className="opacity-banner-promotional">
                    <div className="container-information-contact-banner-promotional">
                        < LinkWithParagraph Content="Linkedin"  Link="https://linkedin/in/eliud-cesar"  />
                        < LinkWithParagraph Content="Instagram" Link="https://instagram/eliud--cesar"   />
                        < LinkWithParagraph Content="Whatsapp"  Link="https://wa.me/7411131023"         />
                    </div>
                </div>

            </aside>
        </>
        )
    }
}



export default BannerPromotional;
